export default __webpack_public_path__ + "static/smoke_bunker-8f9bea3211171c997cc7230472fb0688.png";